import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/components/theme-provider";
import { HelmetProvider } from "react-helmet-async";
import Index from "./pages/Index";
import Blog from "./pages/Blog";
import BlogPost from "./pages/BlogPost";
import Admin from "./pages/Admin";
import About from "./pages/About";
import NotFound from "./pages/NotFound";
import AdminLogin from "./pages/AdminLogin";
import { useEffect, useState, createContext } from "react";

const queryClient = new QueryClient();

export const AdminAuthContext = createContext({ isAdmin: false, setIsAdmin: (_: boolean) => {} });

const App = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  useEffect(() => {
    fetch("/backend/admin_auth.php", { credentials: "include" })
      .then(res => {
        if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
        return res.json();
      })
      .then(data => setIsAdmin(data.authenticated))
      .catch(() => setIsAdmin(false));
  }, []);

  return (
    <HelmetProvider>
      <AdminAuthContext.Provider value={{ isAdmin, setIsAdmin }}>
        <QueryClientProvider client={queryClient}>
          <ThemeProvider defaultTheme="system" storageKey="ui-theme">
            <TooltipProvider>
              <Toaster />
              <Sonner />
              <BrowserRouter>
                <Routes>
                  <Route path="/" element={<Index />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogPost />} />
                  <Route path="/admin-login" element={<AdminLogin />} />
                  <Route path="/admin" element={isAdmin ? <Admin /> : <Navigate to="/admin-login" />} />
                  <Route path="/about" element={<About />} />
                  {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
                  <Route path="*" element={<NotFound />} />
                </Routes>
              </BrowserRouter>
            </TooltipProvider>
          </ThemeProvider>
        </QueryClientProvider>
      </AdminAuthContext.Provider>
    </HelmetProvider>
  );
};

export default App;
